import { combineReducers } from 'redux'
import campaigns from './campaigns'
import trackedAccountProviders from './trackedAccountProviders'
import trackedAccounts from './trackedAccounts'
import withdrawalAccounts from './withdrawalAccounts'
import communities from './communities'
import roundups from './roundups'
import tithes from './tithes'
import processedTransactions from './processedTransactions'

export default combineReducers({
  campaigns,
  trackedAccountProviders,
  trackedAccounts,
  withdrawalAccounts,
  communities,
  roundups,
  tithes,
  processedTransactions
})
